export const TABS_HEIGHT = 59;
export const STICKY_HEADER_HEIGHT = 72;
export const SUBSCRIPTION_TOP_BANNER_HEIGHT = 40;
export const MAIN_SITE_HEADER_HEIGHT = 55;
export const ADMIN_HEADER_HEIGHT = 50;
